module.exports = __webpack_public_path__ + "static/img/demo-image.a72b71e.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/testMapinspect/img/demo-image.png
// module id = 4OdC
// module chunks = 1